import { ActivityType } from 'modules/trainingLibrary/TrainingLibrary/types'

const routes = {
  root: `/${ActivityType.DistanceCourses}`,
}

export default routes
